import { render, staticRenderFns } from "./loginsl.vue?vue&type=template&id=12980ff8&scoped=true&"
import script from "./loginsl.vue?vue&type=script&lang=js&"
export * from "./loginsl.vue?vue&type=script&lang=js&"
import style0 from "./loginsl.vue?vue&type=style&index=0&id=12980ff8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12980ff8",
  null
  
)

export default component.exports